// API bindings: llm (Auto generated)

"use strict";

import { RequestErrorHandler, RequestParams, CommonAuthenticatedErrorHandler } from "@asanrom/request-browser";
import { getApiUrl } from "./utils";
import { LLmAssistantDetails, McpServerDetails } from "./definitions";

export class ApiLlm {
    /**
     * Method: GET
     * Path: /llm/assistant
     * Gets the connection details for the LLM chat assistant
     * Requires permission: llm.use
     * @returns The request parameters
     */
    public static GetChatAssistantConnectionDetails(): RequestParams<LLmAssistantDetails, GetChatAssistantConnectionDetailsErrorHandler> {
        return {
            method: "GET",
            url: getApiUrl(`/llm/assistant`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: GET
     * Path: /llm/mcp
     * Gets the connection details for the MCP server
     * Requires permission: llm.use
     * @returns The request parameters
     */
    public static GetMcpServerDetails(): RequestParams<McpServerDetails, GetMcpServerDetailsErrorHandler> {
        return {
            method: "GET",
            url: getApiUrl(`/llm/mcp`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(403, "*", handler.forbidden)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }
}

/**
 * Error handler for GetChatAssistantConnectionDetails
 */
export type GetChatAssistantConnectionDetailsErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Error handler for GetMcpServerDetails
 */
export type GetMcpServerDetailsErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 403
     */
    forbidden: () => void;
};

